module.exports = __webpack_public_path__ + "static/image4-d4742e530954247fbac164fec8644593.jpg";